import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggleable"];

  toggle() {
    this.toggleableTargets.forEach((toggleable) => {
      toggleable.classList.toggle("hidden");
    });
  }
}
